<template>
  <md-popup
    class="md-cutter"
    :class="classNames"
    v-model="isVisible"
    :mask="false"
  >
    <div class="md-cutter__wrap">
      <div class="md-cutter__wrap--area"></div>
    </div>
    <div class="md-cutter__buttons">
      <slot name="buttons">
        <md-button
          class="md-cutter__buttons--cancel"
          type="text"
          @click="cancelHandler"
          :style="cancelStyle"
          >{{ cancelText }}</md-button
        >
        <md-button
          class="md-cutter__buttons--confirm"
          type="text"
          @click="confirmHandler"
          :style="confirmStyle"
          >{{ confirmText }}</md-button
        >
      </slot>
    </div>
  </md-popup>
</template>

<script>
import Croppie from 'croppie'
import visibleMixin from '@/mixin/visible'
export default {
  name: 'imageCroppie',
  mixins: [visibleMixin],
  props: {
    file: String,
    cancelBtn: {
      type: [String, Object],
      default: '取消'
    },
    confirmBtn: {
      type: [String, Object],
      default: '确认'
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    resultType: {
      type: String,
      default: 'base64',
      validator(val) {
        return ~['base64', 'blob', 'rawcanvas', 'canvas'].indexOf(val)
      }
    }
  },
  computed: {
    confirmText() {
      return (this.confirmBtn || {}).text || this.confirmBtn
    },
    cancelText() {
      return (this.cancelBtn || {}).text || this.cancelBtn
    },
    cancelStyle() {
      /* eslint-disable */
      return (this.cancelBtn || {}).color
        ? {
            color: this.cancelBtn.color
          }
        : null
    },
    confirmStyle() {
      return (this.confirmBtn || {}).color
        ? {
            color: this.confirmBtn.color
          }
        : null
      /* eslint-enable */
    },
    markW() {
      // 左右各留16像素
      return this.width || document.body.clientWidth - 16 * 2
    },
    markH() {
      return this.height || (this.markW * 5) / 8
    }
  },
  watch: {
    isVisible(val) {
      if (val) {
        if (!this.croppie) {
          let $toast = this.$Toast({
            type: 'loading',
            content: '加载中',
            duration: 0
          }).show()
          let _img = new Image()
          _img.src = this.file
          _img.style.display = 'none'
          _img.onload = async () => {
            $toast && $toast.hide()
            setTimeout(() => {
              _img = null
            }, 50)
          }
          this.croppie = new Croppie(
            document.querySelector('.md-cutter__wrap--area'),
            {
              showZoomer: false, // 隐藏滑块
              viewport: {
                width: this.markW,
                height: this.markH
              },
              enableExif: false // 纠正旋转角度
            }
          )
        }
        setTimeout(() => {
          this.croppie.bind({
            url: this.file,
            zoom: 0.00001
          })
        }, 50)
      } else {
        if (this.croppie) {
          this.croppie.destroy()
          this.croppie = null
        }
      }
    }
  },
  components: {},
  data() {
    return {
      croppie: null
    }
  },
  methods: {
    cancelHandler(e) {
      this.hide()
      this.$emit('cancel', e)
    },
    confirmHandler() {
      let $toast = this.$Toast({
        type: 'loading',
        content: '加载中',
        duration: 0
      }).show()
      setTimeout(() => {
        this.croppie
          .result({
            type: this.resultType,
            size: 'original'
          })
          .then(resp => {
            this.hide()
            $toast && $toast.hide()
            this.$emit('confirm', resp)
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      }, 100)
    }
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.md-cutter {
  height: 100vh;
  width: 100vw;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 1);
  z-index: 1999;
  transform: translate3d(0, 0, 0);
  :deep(img) {
    width: auto;
    left: 0;
  }
}
.fade-zoom-enter-active {
  .md-cutter {
    animation: cutter-zoom 0.4s;
  }
}

@keyframes cutter-fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes cutter-zoom {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}
</style>
